<script setup lang="ts">
import { ref } from 'vue';
import { useAuditUser } from '@/composables/useAuditUser';
import CaregiverChangeEmailDialog from '@/components/audit/caregiver-change-email-dialog.vue';

const { auditUser, logout } = useAuditUser();
const showChangeEmailDialog = ref(false);
</script>
<template>
  <v-app-bar :elevation="2">
    <a
      class="logo-link"
      :href="auditUser ? auditUser.mainUrl : '/audit/login'"
    >
      <v-img
        class="ml-2 ml-sm-6"
        src="@assets/images/logo.png"
        max-height="100"
        max-width="100"
        contain
      />
    </a>
    <v-spacer />
    <v-menu v-if="auditUser">
      <template #activator="{ props }">
        <v-btn
          icon="mdi-account-circle"
          size="large"
          color="primary"
          v-bind="props"
        />
      </template>
      <v-list>
        <v-list-item class="text-body-2">
          <v-icon icon="mdi-account-outline" />
          {{ auditUser?.displayRole }}
        </v-list-item>
        <v-list-item class="text-body-2">
          <v-icon icon="mdi-email-outline" />
          {{ auditUser?.displayEmail }}
        </v-list-item>
        <v-list-item v-if="auditUser?.role === 'caregiver'">
          <v-btn
            block
            variant="text"
            prepend-icon="mdi-email-edit"
            @click="showChangeEmailDialog = true"
          >
            Cambiar Correo
          </v-btn>
        </v-list-item>
        <v-list-item v-if="auditUser?.role === 'caregiver'">
          <v-btn
            block
            variant="text"
            prepend-icon="mdi-lock-reset"
            href="/caregivers/password/new"
          >
            Cambiar Contraseña
          </v-btn>
        </v-list-item>
        <v-list-item>
          <v-btn
            block
            @click="logout"
          >
            Cerrar Sesión
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
    <caregiver-change-email-dialog
      v-if="auditUser && auditUser.role === 'caregiver'"
      v-model="showChangeEmailDialog"
    />
  </v-app-bar>
</template>
<style scoped>
.logo-link {
  display: inline-block;
  width: 100px;
}

@media (min-width: 600px) {
  .logo-link {
    width: 150px;
  }
}
</style>
